import { getDayInfo } from './date-utils.js';

let localCalendarCache = null;

export async function showCardByDate(dateObj) {
  const { dayNumber } = getDayInfo(dateObj);
  const dayData = await loadDayData('default-calendar', dayNumber);
  
  if (!dayData) {
    console.error('No se pudieron cargar los datos del día', dayNumber);
    showErrorCard(dayNumber);
    return;
  }

  const wasOpened = checkIfDayWasOpened(dayNumber);
  renderCard(dayNumber, dayData, wasOpened);
}

async function loadDayData(calendarId, dayNumber) {
  try {
    if (!localCalendarCache) {
      const res = await fetch('/data/default-calendar.json');
      localCalendarCache = await res.json();
    }
    const day = localCalendarCache.days.find(d => d.day === dayNumber);
    if (day) {
      return {
        title: day.title,
        mainPhrase: day.mainPhrase,
        mission: day.mission,
        quote: day.quote,
        quoteAuthor: day.quoteAuthor,
        category: day.category,
        icon: day.icon
      };
    }
    return null;
  } catch (error) {
    console.error('Error cargando datos del día (JSON local):', error);
    return null;
  }
}

export async function hasDataForDate(dateObj) {
  const { dayNumber } = getDayInfo(dateObj);
  try {
    if (!localCalendarCache) {
      const res = await fetch('/data/default-calendar.json');
      localCalendarCache = await res.json();
    }
    return localCalendarCache.days.some(d => d.day === dayNumber);
  } catch (e) {
    return false;
  }
}

function renderCard(dayNumber, dayData, wasOpened) {
  // Rellenar datos
  document.getElementById('card-front-number').textContent = dayNumber;
  document.getElementById('card-front-title').textContent = dayData.title || `Día ${dayNumber}`;
  
  // Contenido Interior
  const innerNumber = document.getElementById('card-inner-number');
  if (innerNumber) innerNumber.textContent = dayNumber;

  const headerTitle = document.getElementById('card-header-title');
  if (headerTitle) headerTitle.textContent = dayData.title || `Día ${dayNumber}`;

  document.getElementById('card-main-phrase').textContent = dayData.mainPhrase;
  document.getElementById('card-mission-text').textContent = dayData.mission;
  document.getElementById('card-quote-text').textContent = dayData.quote;
  document.getElementById('card-quote-author').textContent = `— ${dayData.quoteAuthor}`;

  const cardWrapper = document.querySelector('.card-wrapper');
  const card = document.querySelector('.card');
  const box = document.getElementById('gift-box');

  // Resetear estados
  card.classList.remove('flipped');
  cardWrapper.classList.remove('visible');
  box.classList.remove('open');
  
  // Limpiar eventos anteriores
  const newBox = box.cloneNode(true);
  box.parentNode.replaceChild(newBox, box);
  const activeBox = document.getElementById('gift-box'); // Referencia al nuevo elemento

  const newCard = card.cloneNode(true);
  card.parentNode.replaceChild(newCard, card);
  const activeCard = document.querySelector('.card');

  if (!wasOpened) {
    // MODO CAJA CERRADA
    activeBox.style.display = 'block';
    activeBox.classList.remove('open');
    cardWrapper.classList.remove('visible');

    // Click en la caja para abrir
    activeBox.onclick = () => {
      activeBox.classList.add('open');
      
      // Marcar como abierto
      markDayAsOpened('default-calendar', dayNumber);

      // La tarjeta sube después de que la tapa se abre un poco
      setTimeout(() => {
        cardWrapper.classList.add('visible');
      }, 800);
    };
  } else {
    // MODO YA ABIERTO
    // La caja aparece ya abierta y la tarjeta visible
    activeBox.style.display = 'block';
    activeBox.classList.add('open');
    cardWrapper.classList.add('visible');
    
    // Deshabilitar transición inicial para que no se vea la animación al cargar
    activeBox.style.transition = 'none';
    setTimeout(() => activeBox.style.transition = '', 100);
  }

  // Click en la tarjeta para girar
  activeCard.onclick = (e) => {
    // Si ya está girada, no hacer nada (solo scroll)
    if (activeCard.classList.contains('flipped')) return;

    e.stopPropagation();
    activeCard.classList.add('flipped');
    
    // Verificar scroll al terminar la transición (0.8s)
    setTimeout(checkScroll, 850);
  };
}

function checkScroll() {
  const content = document.getElementById('card-content-scroll');
  const indicatorDown = document.getElementById('scroll-indicator-down');
  const indicatorUp = document.getElementById('scroll-indicator-up');
  
  if (!content || !indicatorDown || !indicatorUp) return;

  const updateIndicators = () => {
    const scrollTop = content.scrollTop;
    const scrollHeight = content.scrollHeight;
    const clientHeight = content.clientHeight;
    const isScrollable = scrollHeight > clientHeight;

    // Indicador Abajo: Visible si hay contenido abajo
    if (isScrollable && scrollTop + clientHeight < scrollHeight - 10) {
      indicatorDown.classList.add('visible');
    } else {
      indicatorDown.classList.remove('visible');
    }

    // Indicador Arriba: Visible si hemos bajado
    if (isScrollable && scrollTop > 10) {
      indicatorUp.classList.add('visible');
    } else {
      indicatorUp.classList.remove('visible');
    }
  };

  // Inicializar
  updateIndicators();
  
  // Evento Scroll
  content.onscroll = updateIndicators;

  // Eventos Click en Indicadores
  indicatorDown.onclick = (e) => {
    e.stopPropagation();
    content.scrollBy({ top: 150, behavior: 'smooth' });
  };

  indicatorUp.onclick = (e) => {
    e.stopPropagation();
    content.scrollBy({ top: -150, behavior: 'smooth' });
  };
}

function showErrorCard(dayNumber) {
  document.getElementById('card-front-title').textContent = `Día ${dayNumber}`;
  document.getElementById('card-main-phrase').textContent = 'No se pudo cargar el contenido de este día.';
  document.getElementById('card-mission-text').textContent = 'Por favor, intenta de nuevo más tarde.';
  document.getElementById('card-quote-text').textContent = 'La paciencia es la fortaleza del débil y la impaciencia la debilidad del fuerte.';
  document.getElementById('card-quote-author').textContent = '— Immanuel Kant';
}

function checkIfDayWasOpened(dayNumber) {
  const key = `lc_opened_default-calendar`;
  const openedDays = JSON.parse(localStorage.getItem(key) || '[]');
  return openedDays.includes(dayNumber);
}

function markDayAsOpened(calendarId, dayNumber) {
  const key = `lc_opened_${calendarId}`;
  let openedDays = JSON.parse(localStorage.getItem(key) || '[]');
  if (!openedDays.includes(dayNumber)) {
    openedDays.push(dayNumber);
    localStorage.setItem(key, JSON.stringify(openedDays));
  }
}

